export type { LoadingProps } from './Loading'
export { Loading } from './Loading'
